<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong>User BMI Report</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Academic Year"
            outlined
            @change="getStd()"
            persistent-hint
            hint="Select academic year"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            dense
            required
            outlined
            rounded
            color="#0F2027"
            v-model="sem"
            :items="semester_list"
            item-text="display_name"
            item-value="id"
            label="Semester"
            persistent-hint
            hint="Select semester"
            @click="putallnull()"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            item-value="std_id"
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            persistent-hint
            hint="Select standard"
          />
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="status"
            :items="status_list"
            item-text="name"
            item-value="id"
            label="Status"
            outlined
            persistent-hint
            hint="Select Status"
          />
        </v-col>

        <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="sel_ay_data && sel_std_data && status"
        >
          <v-btn
            class="mt-6 button"
            @click="getreport()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="bmilist != ''">
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-btn
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'BMIReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
        </v-col>
        <!-- search code shiv -->
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search by Student name or by Registration Number"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-col cols="12" sm="12" md="12" v-if="bmilist != ''"> -->
      <div id="my-table-id">
        <div class="scroll">
          <v-simple-table fixed-header dense class="elevation-1" height="500px">
            <thead>
              <tr>
                <th class=""><center>Sr. No.</center></th>
                <th class=""><center>Roll No.</center></th>
                <th class=""><center>Registration No.</center></th>
                <th class=""><center>Name</center></th>
                <th class=""><center>Height (centimeter)</center></th>
                <th class=""><center>Weight (Kg)</center></th>
                <th class=""><center>BMI</center></th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr v-for="(s, index) in bmilist" :key="s.lid"> -->
              <tr v-for="(s, index) in filteredItems" :key="s.id">
                <td>{{ index + 1 }}</td>
                <td>{{ s.rollno }}</td>
                <td>{{ s.registration_number }}</td>
                <td>{{ s.name }}</td>
                <td>
                  {{ s.height }}
                </td>
                <td>
                  {{ s.weight }}
                </td>

                <td>
                  {{ s.bmi }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <br />
        </div>
      </div>
      <!-- </v-col> -->
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    overlay: false,
    valid: false,
    errorMsg: {},
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    uid_domain: "",
    fetch_loader: false,
    dialog: false,
    userlist: {},
    usertype: {},
    ay_std_div_list: null,
    sel_ay_data: null,
    std_div_list: null,
    sel_std_data: null,
    div_list: null,
    div: null,
    semester_list: null,
    sem: null,
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    status: null,
    // headers: [
    //     { text: "Height (Centimeter)", value: "height" },
    //     { text: "Weight (Kg)", value: "weight" },
    //     { text: "BMI", value: "bmi" },
    //     { text: "Actions", value: "action", sortable: false },
    // ],
    standardlist: "",
    // editedIndex: -1,
    // editedItem: {
    //     height: "",
    //     weight: "",
    //     bmi: "",
    // },
    // defaultItem: {
    //     subject_code: "",
    //     subject_name: "",
    //     bmi: "",
    // },
    bmilist: "",
  }),
  computed: {
    filteredItems() {
      return this.bmilist.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.registration_number
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
    formTitle() {
      return this.editedIndex === -1
        ? "New BMI Calculation"
        : "Edit BMI Calculation";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    putallnull() {
      this.div_list = null;
    },

    getreport() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data,
        sem: this.sem,
        status: this.status,
      };
      this.fetch_loader = true;
      this.search = "";
      axios
        .post("/Examination/bmiReport", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.bmilist = res.data.bmilist;
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.fetch_loader = false;
        })
        .finally(() => {
          "use strict";
          this.fetch_loader = false;
        });
    },
    getStd() {
      this.std_div_list = ["All"];
      this.sel_std_data = "All";
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
      this.std_div_list.unshift("All");
      this.sel_std_data = this.std_div_list[0];
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.overlay = false;
          this.ay_std_div_list = res.data.data;
          //     this.sel_ay_data = res.data.curr_ay;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    save() {
      axios
        .post("/Examination/saveBMICalculation")
        .then((res) => {
          // if (res.data.msg == "200") {
          //     this.onLoad();
          //     this.showSnackbar("#4caf50", "New BMI calculation added Successfully..."); // show snackbar on success
          // } else if (res.data.msg == "300") {
          //     this.showSnackbar("#4caf50", res.data.description); // show snackbar on success
          // }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
        });
      this.close();
    },
  },
};
//};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
.scroll {
  overflow-x: scroll;
}
.box {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  /* border: 2px solid #0f2027 !important; */
}
/* .button {
        border: 2px solid #0f2027 !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    } */
.button:hover {
  color: white;
  background: #0f2027 !important;
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
input[type="number"] {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0rem !important;
  padding: 0rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
</style>
